(function () {
	const canvas = document.querySelector('[data-actor]');
	if (!canvas) return false;
	window.c = canvas.getContext('2d');

	const ACTOR = canvas.dataset.actorName;
	const MAXFRAMES = canvas.dataset.actorMaxFrames;

	const SRC = '/dist/img/canvas/' + ACTOR + '/';

	let SCREENFORMAT = mq();
	let STILLS = createStills();
	let CANVASRATIO = canvasRatio();
	let RATIO = ratio();

	let timer; // variable used for declaring and clearing a Timeout

	let mouseMoved = false;

	function reset (init = false) {
		clearTimeout(timer);

		timer = setTimeout(function () {
			canvas.width = canvas.parentElement.clientWidth;
			canvas.height = canvas.parentElement.clientHeight;

			CANVASRATIO = canvasRatio();
			RATIO = ratio();

			if (SCREENFORMAT !== mq()) {
				SCREENFORMAT = mq();
				STILLS = createStills();
			}

			if (typeof init == 'boolean' && init) {
				canvas.parentElement.style.backgroundImage = 'url(' + STILLS[0].src + ')';
				const timeoutTime = window.matchMedia('(orientation: portrait)').matches ? 1250 : 250;
				setTimeout(() => document.querySelector('.canvas-loading').classList.remove('canvas-loading'), timeoutTime);

				hdDrawer(STILLS[0], function () {
					if (document.querySelector('.canvas-loading')) {
						document.querySelector('.canvas-loading').classList.remove('canvas-loading');
					}
				});

				if (window.matchMedia('(hover: hover)').matches) canvas.parentElement.addEventListener('mousemove', mouseListener);
				else window.addEventListener('deviceorientation', deviceOrientationListener); // Needs HTTPS

				window.addEventListener('resize', reset);
				window.addEventListener('orientationchange', function () {
					window.removeEventListener('deviceorientation', deviceOrientationListener); // Needs HTTPS
					setTimeout(reset, 1000);
				});
			}

			if (typeof init !== 'boolean' || !init) {
				const newImg = sessionStorage.lastSrc.replace(/\/(lg|md|sm)\//, '/' + mq() + '/');

				window.addEventListener('deviceorientation', deviceOrientationListener);

				hdDrawer(newImg);
			}
		}, 150);
	}

	function ratio () {
		switch (mq()) {
			case ('lg'):
				return 9 / 16;
			case ('md'): 
				return 3 / 4;
			case ('sm'):
				return 16 / 11;
		}
	}

	function canvasRatio () { return canvas.width / canvas.height }

	function mq (str, val) { // Media query management at reset
		switch (true) {
			case (str && val && window.matchMedia(str).matches): // Custom, if requested
				return val;
			case (canvas.clientWidth < 512): // Mobile
				return 'sm';
			case (canvas.clientWidth <= 1024): // Tablet && JC
				return 'md';
			default:
				return 'lg';
		}
	}

	function pos (img, direction = 'x') {
		let XPERC = 50;
		let YPERC = 50;

		switch (SCREENFORMAT) {
			case 'lg':
				XPERC = 10, YPERC = 35;
				if (ACTOR == 'gaetan') YPERC = 100;

				break;
			case 'md':
				XPERC = 90, YPERC = 25; break;
			case 'sm':
				XPERC = 60, YPERC = 30; break;
		}

		if (direction == 'y') {
			return Math.round((canvas.height - (canvas.width * RATIO)) / 100 * YPERC);
		} else {
			return Math.round((canvas.width - canvas.height / RATIO) / 100 * XPERC);
		}
	}

	function drawer (img, cb) {
		if (!img) return false;

		if ((img.width / img.height) <= CANVASRATIO) { // image higher than canvas
			c.drawImage(img, 0, pos(img, 'y'), canvas.width, canvas.width * RATIO);
		} else { // image larger than canvas
			c.drawImage(img, pos(img, 'x'), 0, canvas.height / RATIO, canvas.height);
		}

		if (cb) cb();
	}

	function hdDrawer (lowSrc, cb = null) {
		let img;
		if (typeof lowSrc == 'string') {
			img = new Image();
			img.src = lowSrc.replace('/low/', '/');
		} else {
			img = lowSrc;
			img.src = img.src.replace('/low/', '/');
		}

		img.addEventListener('load', function () { drawer(img, cb) });

		sessionStorage.lastSrc = img.src;
	}

	function createStills (hd = false) {
		const arr = [];

		let src = SRC + SCREENFORMAT;

		src += !hd ? '/low/' : '/';

		let it = 1;
		while (it <= MAXFRAMES) {
			let numeral = it;

			if (it < 100) numeral = '0' + it;
			if (it < 10) numeral = '00' + it;

			arr.push(new Image());
			arr[arr.length - 1].src = src + ACTOR + '_' + numeral + '.jpg';

			it++;
		}

		return arr;
	}

	function mouseListener (e) {
		const parent = canvas.parentElement;
		const bounds = parent.getBoundingClientRect();
		const positions = {
			l: bounds.left + parseInt(window.getComputedStyle(parent).borderLeftWidth.match(/\d+/)[0]),
			r: bounds.left + bounds.width - parseInt(window.getComputedStyle(parent).borderRightWidth.match(/\d+/)[0])
		}

		const x = e.clientX;
		if (x < positions.l || x > positions.r) return false;
		clearTimeout(timer);

		let proportion = Math.floor((x - positions.l) / (positions.r - positions.l) * (MAXFRAMES - 1));

		drawer(STILLS[proportion]);

		timer = setTimeout(function () {
			hdDrawer(STILLS[proportion].src);
		}, 150);
	}

	function deviceOrientationListener (e) {
		const parent = canvas.parentElement;
		const bounds = parent.getBoundingClientRect();
		const positions = {
			l: bounds.left + parseInt(window.getComputedStyle(parent).borderLeftWidth.match(/\d+/)[0]),
			r: bounds.left + bounds.width - parseInt(window.getComputedStyle(parent).borderRightWidth.match(/\d+/)[0])
		}

		let direction;

		if (window.matchMedia('(orientation: portrait)').matches) direction = e.gamma;
		else direction = e.beta;

		const x = Math.min(Math.max((direction + 30) / 60 * (MAXFRAMES - 1), 0), MAXFRAMES - 1);

		if (x < 0 || x > MAXFRAMES - 1) return false;

		clearTimeout(timer);

		drawer(STILLS[Math.round(x)]);

		timer = setTimeout(function () {
			hdDrawer(STILLS[Math.round(x)].src);
		}, 150);
	}

	reset(true);
})();